export class APISession {
    name = '';
    tags: any = {};
    serviceId: string;
    token: string;
    type: string;
    servicePolicies: any[];
    identityId: string;
    service: any;
    edgeRouters: any[];
    isCertExtendable: boolean;
    isMfaComplete: boolean;
    isMfaRequired: boolean;
    updatedAt: any;
    createdAt: any;
    id: string;
}
